import {inject} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot} from '@angular/router';
import {Store} from '@ngxs/store';
import {AuthState} from '../state/auth.state';
import {filter, map} from 'rxjs/operators';
import {Observable, of} from 'rxjs';

export const authGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Observable<boolean> => {
  const store = inject(Store);
  const router = inject(Router);

  const authenticated = store.selectSnapshot(AuthState.isAuthenticated);
  if (!authenticated) {
    router.navigate(['/login'], {
      queryParams: {
        redirect: state.url,
      }
    }).then();
    return of(authenticated);
  }
  if (!route.data.module) {
    return of(authenticated);
  }

  return store.select(AuthState.modules).pipe(
    filter(modules => modules.length > 0),
    map(modules => modules.includes(route.data.module))
  );
};
